var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81579 3.76316C4.68215 3.76316 3.76316 4.68215 3.76316 5.81579V20.1842C3.76316 21.3178 4.68215 22.2368 5.81579 22.2368H7.57104C7.95396 22.2368 8.26438 22.5473 8.26438 22.9302V25.3067C8.26438 25.6896 7.95396 26 7.57104 26H5.81579C2.60381 26 0 23.3962 0 20.1842V5.81579C0 2.60382 2.60381 0 5.81579 0H7.57104C7.95396 0 8.26438 0.310416 8.26438 0.693334V3.06982C8.26438 3.45274 7.95396 3.76316 7.57104 3.76316H5.81579ZM20.1842 3.76316H18.429C18.046 3.76316 17.7356 3.45274 17.7356 3.06982V0.693333C17.7356 0.310416 18.046 0 18.429 0H20.1842C23.3962 0 26 2.60382 26 5.81579V20.1842C26 23.3962 23.3962 26 20.1842 26H18.429C18.046 26 17.7356 25.6896 17.7356 25.3067V22.9302C17.7356 22.5473 18.046 22.2368 18.429 22.2368H20.1842C21.3178 22.2368 22.2368 21.3178 22.2368 20.1842V5.81579C22.2368 4.68215 21.3178 3.76316 20.1842 3.76316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1141ef2edbeab721df49ec7b7321eb65.svg";
export { ForwardRef as ReactComponent };